import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Badge } from "@/components/ui/badge";
import { Database } from "@/integrations/supabase/types";

type SubscriptionTier = Database['public']['Enums']['subscription_tier'];

export const SubscriptionInfo = () => {
  const [subscriptionTier, setSubscriptionTier] = useState<SubscriptionTier>('basic');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getSubscriptionInfo = async () => {
      try {
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('subscription_tier')
          .maybeSingle();

        if (error) {
          console.error("Error fetching subscription:", error);
          return;
        }

        if (profile) {
          console.log("Found subscription tier:", profile.subscription_tier);
          setSubscriptionTier(profile.subscription_tier);
        }
      } catch (error) {
        console.error("Error in getSubscriptionInfo:", error);
      } finally {
        setLoading(false);
      }
    };

    getSubscriptionInfo();
  }, []);

  if (loading) {
    return null;
  }

  const getBadgeVariant = (tier: SubscriptionTier) => {
    switch (tier) {
      case 'professional':
        return 'secondary';
      case 'enterprise':
        return 'default';
      default:
        return 'outline';
    }
  };

  const formatTierName = (tier: string) => {
    return tier.charAt(0).toUpperCase() + tier.slice(1);
  };

  return (
    <section className="bg-white shadow-sm rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Subscription</h2>
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <p className="text-sm text-muted-foreground">Current Plan:</p>
          <Badge variant={getBadgeVariant(subscriptionTier)}>
            {formatTierName(subscriptionTier)}
          </Badge>
        </div>
        <p className="text-sm text-muted-foreground">
          Subscription management features coming soon.
        </p>
      </div>
    </section>
  );
};